interface ILinkedTreeNode extends Hierarchy.IHierarchyItem {
    parent?: ILinkedTreeNode;
}

export class HierarchyPrune {

    constructor(private hierarchy: Hierarchy.IHierarchyItem[]) {

    }

    private clone(item: Hierarchy.IHierarchyItem): ILinkedTreeNode {
        let result = Object.assign({}, item);
        result.children = [];
        return result;
    }
    
    prune(filter: string): Hierarchy.IHierarchyItem[] {

        let results = [];

        if (!filter || !filter.length) {
            return results;
        }

        filter = filter.toLowerCase();

        let root = null;

        let keep = (item: ILinkedTreeNode) => {
            if (!item) {
                return;
            }
            item['keep'] = true;
            keep(item.parent);
        };

        let mark = (parent: Hierarchy.IHierarchyItem, children: Hierarchy.IHierarchyItem[], found: boolean) => {

            let match = parent.name.toLowerCase().includes(filter);

            if (match || found) {
                keep(parent);
            }

            children = children || [];

            children.forEach(child => {

                let clone = this.clone(child);

                clone.parent = parent;

                parent.children.push(clone);

                mark(clone, child.children, match || found);
                
            });

        };

        let sweep = (parent: ILinkedTreeNode) => {
            parent.children = parent.children.filter(child => !!child['keep']);
            parent.children.forEach(child => {
                sweep(child);
            });
        };

        this.hierarchy.forEach(item => {
            if (item && item.children) {
                root = this.clone(item);
                mark(root, item.children, false);
                sweep(root);
                if (root['keep']) {
                    results.push(root);
                }
                root = null;
            }
        });
        

        return results;
    }

}
